export const QUERY__ORDERS = 'orders';
export const QUERY__USER_ORDERS = 'user-orders';
export const QUERY__ORDER_FULL_INFO = 'order-full-info';
